import { Route, Routes } from 'react-router-dom';
import GlobalStreams from './components/GlobalStreams';
import Layout from './components/Layout';
import { UserSessionProvider } from './account/UserSession';
import MarketsPage from './pages/MarketsPage';
import MarketPage from './pages/MarketPage';
import PortfolioPage from './pages/PortfolioPage';
import NotFoundPage from './pages/NotFoundPage';
import LearnPage from './pages/LearnPage';
import PrivacyPage from './pages/PrivacyPage';
import { WalletProvider } from './wallet/WalletProvider';
import { GhostProvider } from './wallet/GhostProvider';
import { AgentProvider } from './agent/AgentProvider';
import { AgentEnablingModal } from './agent/AgentControls';
import { TourProvider } from './tour/TourProvider';

export default function App() {
  return (
    <WalletProvider>
      <GlobalStreams />
      <GhostProvider>
        <UserSessionProvider>
          <AgentProvider>
            <TourProvider>
              <Routes>
                <Route element={<Layout />}>
                  <Route index element={<MarketsPage />} />
                  <Route path="market/:outcomeId" element={<MarketPage />} />
                  <Route path="portfolio" element={<PortfolioPage />} />
                  <Route path="learn" element={<LearnPage />} />
                  <Route path="privacy" element={<PrivacyPage />} />
                  <Route path="*" element={<NotFoundPage />} />
                </Route>
              </Routes>
            </TourProvider>
            <AgentEnablingModal />
          </AgentProvider>
        </UserSessionProvider>
      </GhostProvider>
    </WalletProvider>
  );
}
